import { configureStore } from "@reduxjs/toolkit";
import { clientFirmsApi } from '../api/clientFirmsApi'

export const store = configureStore({
    reducer: {
        [clientFirmsApi.reducerPath]: clientFirmsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(clientFirmsApi.middleware),
})


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
